(function ($) {
  var ehInternetVideoWithProductsV1 = {
    init: function (context, settings) {
      if ($.isFunction($.fn.flexslider)) {
        $('.eh-internet_video_with_products_v1 .products').once('products-flexslider').each(function () {
          var thisFormatter = $(this);
          var flexsliderID = thisFormatter.children('.flexslider').attr('id');
          var flexslider = $('#' + flexsliderID);

          // Check slides length and add items class if there are more than one slide
          if (thisFormatter.children('.flexslider').find('.slides li').length > 1) {
	  // more than one slide
	  thisFormatter.children('.flexslider').addClass('items');
          } else {
	  // one slide
	  thisFormatter.children('.flexslider').addClass('item');
          }

          var slideshow = false;

          if (flexslider.hasClass('flexslider-slideshow')) {
	  slideshow = true;
          }

          flexslider.fitVids().flexslider({
	  animation: 'slide',
	  before: function (slider) {
	    // stop video
	    var currentSlide = slider.slides.eq(slider.currentSlide);
	    var currentFrame = currentSlide.find('iframe');
	    var currentFrameSrc = currentFrame.attr('src');

	    currentFrame.attr('src', '');
	    currentFrame.attr('src', currentFrameSrc);
	  },
	  itemMargin: 0,
	  itemWidth: 320,
	  minItems: 1,
	  maxItems: 1,
	  slideshow: slideshow,
	  video: true,
	  move: 1,
	  animationLoop: true
          });
        });
      }
    }
  };

  $(window).on('load', function() {
    ehInternetVideoWithProductsV1.init();
  });
})(jQuery);
